import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { useId, useLayoutEffect, useRef, useState } from "react";
import "./OssActionHistoryPanel.css";

export const OssActionHistoryPanel = ({ rows, loading, error, formatTitle, formatStatus, lines = [] }) => {
  const id = useId();
  const [selected, setSelected] = useState(null);
  const listRef = useRef(null);
  const backRef = useRef(null);
  const entryRefs = useRef([]);
  const position = useRef({ top: 0, index: null });
  const row = selected === null ? null : rows[selected];
  const title = (entry) => formatTitle(entry.action_title || entry.title || "이력");
  const note = (entry) => entry.result_note || entry.note || "";
  const line = row && lines.find((entry) => String(entry.order_line_id) === String(row.order_line_id));

  useLayoutEffect(() => {
    if (selected !== null) {
      backRef.current?.focus({ preventScroll: true });
    } else if (position.current.index !== null) {
      if (listRef.current) listRef.current.scrollTop = position.current.top;
      entryRefs.current[position.current.index]?.focus({ preventScroll: true });
    }
  }, [selected]);

  const selectEntry = (index) => {
    position.current = { top: listRef.current?.scrollTop || 0, index };
    setSelected(index);
  };

  return (
    <section className="oss-action-history oss-history-browser" aria-labelledby={`${id}-title`}>
      <div className="oss-action-section-heading oss-history-heading">
        {row ? (
          <Tooltip title="이력 목록으로 돌아가기">
            <IconButton ref={backRef} aria-label="조치 이력 목록으로 돌아가기" onClick={() => setSelected(null)} size="small">
              <ArrowBackRoundedIcon />
            </IconButton>
          </Tooltip>
        ) : <HistoryOutlinedIcon />}
        <h3 id={`${id}-title`}>{row ? "조치 이력 상세" : "조치 이력"}</h3>
        <span>{row ? `${selected + 1} / ${rows.length}` : `${rows.length}건`}</span>
      </div>
      {row ? (
        <div className="oss-action-list oss-history-detail" key="detail" role="region" aria-label="선택한 조치 이력 상세" tabIndex={0}>
          <h4>{title(row)}</h4>
          <dl className="oss-history-facts">
            <div><dt>{row.occurred_at ? "기록 일시" : "확인 예정일"}</dt><dd>{row.occurred_at || row.due_at || "-"}</dd></div>
            <div><dt>{row.history_type === "STATUS" ? "상태 변경" : "처리 상태"}</dt><dd>{formatStatus(row)}</dd></div>
            {line && <div><dt>대상 품목</dt><dd>{line.item_name_snapshot || "-"}</dd></div>}
          </dl>
          <div className="oss-history-full-note">
            <h5>{row.history_type === "STATUS" ? "변경 사유" : "조치 기록"}</h5>
            <p>{note(row) || "추가로 남긴 내용이 없습니다."}</p>
          </div>
        </div>
      ) : (
        <div className="oss-action-list oss-history-entries" key="list" ref={listRef} tabIndex={0} aria-label="조치 이력 목록" aria-busy={loading}>
          {loading ? <div className="oss-action-empty"><CircularProgress size={22} aria-label="이력 불러오는 중" /></div> :
            rows.length ? rows.map((entry, index) => (
              <article className="oss-action-history-entry" key={index}>
                <button type="button" className="oss-history-open" ref={(node) => { entryRefs.current[index] = node; }}
                  aria-label={`${title(entry)} ${entry.occurred_at || entry.due_at || ""} 상세 보기`}
                  onClick={() => selectEntry(index)}>
                  <span className="oss-history-preview">
                    <span className="oss-action-history-meta"><strong>{title(entry)}</strong><time>{entry.occurred_at || entry.due_at || ""}</time></span>
                    <span className="oss-history-status">{formatStatus(entry)}</span>
                    {note(entry) && <span className="oss-history-excerpt">{note(entry)}</span>}
                  </span>
                  <ChevronRightRoundedIcon className="oss-history-chevron" />
                </button>
              </article>
            )) : <p className="oss-action-empty">{error ? "이력을 불러오지 못했습니다." : "등록된 조치 이력이 없습니다."}</p>}
        </div>
      )}
    </section>
  );
};
